/** A provider-kind checkbox's text: what it is, then what that means. */
export function KindLabel({
  title,
  detail,
}: {
  title: string;
  detail: string;
}) {
  return (
    <span className="sk:flex sk:flex-col">
      <span className="sk:font-medium">{title}</span>
      <span className="sk:text-fg-secondary">{detail}</span>
    </span>
  );
}
